import React from 'react';

import { HeadTitle } from '@modules/layout/atoms';

import type { RouteProps } from '@config/routes';

const BaseRoute = (props: RouteProps): React.ReactElement | null => {
    const { title, Component, LayoutComponent, ...otherProps } = props;

    const renderedComponent = (
        <>
            <HeadTitle>{title}</HeadTitle>
            <Component title={title} {...otherProps} />
        </>
    );

    if (LayoutComponent) {
        return <LayoutComponent pageTitle={title}>{renderedComponent}</LayoutComponent>;
    }

    return renderedComponent;
};

export { BaseRoute };
